import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { useChatAssistantFilters } from './hook';
import { ChatAssistantFiltersProps } from './props';
import FieldSelect from '../../../components/general/fields/fieldSelect';

export const ChatAssistantFilters = ({
    onFilter,
    loading,
}: ChatAssistantFiltersProps) => {
    const { formik, projects } = useChatAssistantFilters(onFilter);

    return (
        <Grid container spacing={{ xs: 1.5, md: 1.5 }}>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    touched={formik.touched.description}
                    errors={formik.errors.description}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Configuración inicial"
                    name="initialConfiguration"
                    size="small"
                    touched={formik.touched.initialConfiguration}
                    errors={formik.errors.initialConfiguration}
                    value={formik.values.initialConfiguration}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={projects}
                    label="Proyecto"
                    name="project"
                    size="small"
                    touched={formik.touched.project}
                    errors={formik.errors.project}
                    value={formik.values.project as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
